import * as React from "react";
import {Required} from "./FormStyles";


export const  warning = (showWarning, warningLabel) => showWarning ? <Required> {warningLabel} </Required> : <React.Fragment/>;